export default "__VITE_ASSET__44fb8405__"